export default "__VITE_ASSET__S2aD80LN__"